import { Label } from '@onclicks/sharedcomponents/ui/Label'
import React from 'react'

export const FieldLabel: React.FC<{
  htmlFor: string
  label?: string | null
  required?: boolean | null
}> = ({ htmlFor, label, required }) => (
  <Label htmlFor={htmlFor} className="text-xs font-bold uppercase tracking-widest text-white/60">
    {label}
    {required && (
      <span className="required ml-1 text-primary">
        * <span className="sr-only">(required)</span>
      </span>
    )}
  </Label>
)
